var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Card',{staticClass:"home-card",attrs:{"dis-hover":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }